var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.374,
    height: 18.374,
    viewBox: "0 0 18.374 18.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-alt-circle-right",
    "data-name": "Icon awesome-arrow-alt-circle-right",
    d: "M9.75.563A9.187,9.187,0,1,1,.563,9.75,9.185,9.185,0,0,1,9.75.563Zm-4.3,10.817h4.3v2.626a.445.445,0,0,0,.759.315l4.234-4.256a.44.44,0,0,0,0-.626l-4.234-4.26a.445.445,0,0,0-.759.315V8.12h-4.3a.446.446,0,0,0-.445.445v2.371A.446.446,0,0,0,5.452,11.379Z",
    transform: "translate(-0.563 -0.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleArrowRight);
export default __webpack_public_path__ + "static/media/icon-circle-arrow-right.710bdf65ad9ebdf42a8f578b73879db7.svg";
export { ForwardRef as ReactComponent };